import {
  RateShiftView,
  DetailView,
  DeleteView,
  ReleaseShiftView,
  EditView,
  NotifyTeamMember,
  AuditTrailView,
  AwardTeamMemberView,
  AwardUnavailableView,
  ShiftConflictView,
  AwardShiftBlockView,
} from 'modals/ShiftModal/src/views';
import { PreRequestOptionsView } from 'modals/ShiftModal/src/views/SendToAgenciesView/PreRequestOptionsView';
import { SendToAgenciesSummaryView } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView';
import { PostRequestOptionsView } from 'modals/ShiftModal/src/views/SendToAgenciesView/PostRequestOptionsView';
import { QUERY_shiftModalOrderDetails } from 'queries';
import { UseGQLQueryConfig } from 'hooks/useGQLQuery/useGQLQuery.types';
import { Order, ShiftModalOrderDetailsQuery } from 'types/graphql';
import { AssignToAgencyTeamMemberSummaryView } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/views/AssignToAgencyTeamMemberSummaryView';
import { SelectAgencyTeamMemberView } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/views/SelectAgencyTeamMemberView';
import { TeamMemberUnavailableView } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/views/AssignToAgencyTeamMemberSummaryView/TeamMemberUnavailableView.component';
import { createApolloCache, createApolloClient } from 'providers/ApolloProvider';
import { SelectAgenciesView } from 'modals/ShiftModal/src/views/SendToAgenciesView/SelectAgenciesView/SelectAgenciesView';
import { ShiftUnavailableView } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/views/SelectAgencyTeamMemberView/ShiftUnavailableView.component';
import { RequestTeamMemberView } from 'modals/ShiftModal/src/views/SendToAgenciesView/RequestTeamMemberView/RequestTeamMemberView';
import { ReasonForEdits } from 'modals/ShiftModal/src/views/ReasonForEdits/ReasonForEdits';
import { ConfirmEditsView } from 'modals/ShiftModal/src/views/ConfirmEditsView/ConfirmEditsView';
import { SessionService } from 'services/SessionService';
import { EditingReasonAndNotifyView } from 'modals/ShiftModal/src/views/DetailView/GeneralTab/ReasonForEditingAndNotify';
import { SendToAgencyConfirmationView } from 'modals/ShiftModal/src/views/SendToAgencyConfirmationView';
import { ShiftModalErrorView } from 'modals/ShiftModal/src/views/ShiftModalErrorView';

export type ShiftModalDetailsData = { order: Order };

export const ShiftModalComponentMap = {
  AssignToAgencyTeamMemberSummaryView,
  AssignToAgencyTeamMemberView: SelectAgencyTeamMemberView,
  TeamMemberUnavailableView,
  ShiftUnavailableView,
  DetailView,
  EditView,
  NotifyTeamMember,
  DeleteView,
  RateShiftView,
  ReleaseShiftView,
  PreRequestOptionsView,
  SendToAgenciesSummaryView,
  RequestTeamMemberView,
  PostRequestOptionsView,
  SelectAgenciesView,
  AuditTrailView,
  AwardTeamMemberView,
  AwardUnavailableView,
  ShiftConflictView,
  AwardShiftBlockView,
  ReasonForEdits,
  EditingReasonAndNotifyView,
  ConfirmEditsView,
  SendToAgencyConfirmationView,
  ShiftModalErrorView,
};

export type ShiftModalViewType = keyof typeof ShiftModalComponentMap;

export const ShiftModalViewsWithTabs: ShiftModalViewType[] = ['DetailView'];

const shiftModalApolloClient = createApolloClient({ cache: createApolloCache() });

export const shiftModalDetailsQueryConfig = (
  facility_id: number,
  shift_id?: string,
): UseGQLQueryConfig<
  ShiftModalOrderDetailsQuery,
  ShiftModalDetailsData,
  { id: string | undefined; communityId: number }
> => ({
  key: 'SHIFT_MODAL_DETAILS_QUERY',
  query: QUERY_shiftModalOrderDetails,
  client: shiftModalApolloClient,
  variables: {
    id: shift_id,
    communityId: facility_id,
  },
  // When the order isn't yet resolved (no node returned), return null so
  // useGQLQuery's status stays LOADING and QuerySwitch keeps showing the
  // loading state. Views downstream can therefore assume `data.order` is
  // a non-null Order.
  responseTransformer: (rawData) => {
    const node = rawData?.node;
    if (!node) return null as unknown as ShiftModalDetailsData;
    return { order: node as Order };
  },
  context: {
    headers: {
      'USER-CURRENT-FACILITY-TYPE': SessionService.assertUserType('B2B')
        ? 'Community'
        : 'AgencyCommunity',
      'USER-CURRENT-FACILITY-ID': facility_id,
    },
  },
});
